import {
  Modal as ModalMantine,
  ModalProps as ModalPropsMantine,
} from '@mantine/core'

interface ModalProps extends ModalPropsMantine {
  children: React.ReactNode
}

export const Modal = ({ children, ...rest }: ModalProps) => {
  const { styles, ...restProps } = rest
  return (
    <ModalMantine
      className="--v2"
      {...restProps}
      styles={{
        overlay: {
          zIndex: 11000010,
        },
        inner: {
          zIndex: 11000010,
        },
        content: {
          zIndex: 11000010,
          borderRadius: 20,
        },
        ...styles,
      }}
    >
      {children}
    </ModalMantine>
  )
}
